import { Modal, Button } from '@/components/ui';

const SESSION_KEY = 'exception-modal-shown';

interface ExceptionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/** Returns true if the modal has already been shown this session. */
export function wasExceptionModalShown(): boolean {
  try {
    return sessionStorage.getItem(SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

/** Marks the modal as shown for this session. */
export function markExceptionModalShown(): void {
  try {
    sessionStorage.setItem(SESSION_KEY, '1');
  } catch {
    // sessionStorage unavailable
  }
}

export default function ExceptionModal({ isOpen, onClose }: ExceptionModalProps) {
  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="bg-white rounded-lg  p-6 max-w-md">
        <h3 className="text-lg font-semibold text-neutral-900 mb-3">Exception Hold</h3>
        <p className="text-sm text-neutral-600 mb-4">
          Exception holds require approval before they can be processed by the charting team.
          You can add comments to explain why this exception is needed after the hold is created.
        </p>
        <div className="flex justify-end">
          <Button variant="primary" onClick={onClose}>
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
}
